<template>
  <div style="height:600px; overflow-y:auto; padding:16px;">
    <Form
      :model="resourceItem"
      ref="formValidate"
      :label-width="150"
      :rules="formValidate"
    >
      <FormItem label="资源类型：" prop="resourceTypeM2Ms">
        <Row
          :gutter="8"
          class="margin-bottom-10"
          v-for="(item, index) in resourceItem.resourceTypeM2Ms"
          :key="index"
        >
          <Col :span="22">
            <Cascader
              :data="resourceTypeData"
              v-model="item.resourceTypeIds"
              clearable
              change-on-select
            ></Cascader>
          </Col>
          <Col :span="2">
            <Poptip
              placement="left"
              confirm
              title="确定移除这个类型吗？"
              @on-ok="resourceItem.resourceTypeM2Ms.splice(index, 1)"
            >
              <Button type="error" icon="md-remove" shape="circle"></Button>
            </Poptip>
          </Col>
        </Row>
        <Button
          type="success"
          icon="md-add"
          shape="circle"
          @click="addResourceTypeM2M"
        >
          添加资源类型
        </Button>
      </FormItem>
      <FormItem label="资源方等级：" prop="providerLevel">
        <Select v-model="resourceItem.providerLevel">
          <Option :value="0">优选</Option>
          <Option :value="1">一般</Option>
          <Option :value="2">登记备用</Option>
        </Select>
      </FormItem>
      <FormItem label="公司（团队）名称：" prop="companyName">
        <Input v-model="resourceItem.companyName" autocomplete="off"></Input>
        <span>*请在黑名单列表查询该公司是否存在</span>
      </FormItem>
      <FormItem label="组织类型：" prop="groupType">
        <Select v-model="resourceItem.groupType">
          <Option value="公司">公司</Option>
          <Option value="团队">团队</Option>
          <Option value="个人">个人</Option>
        </Select>
      </FormItem>
      <!-- <FormItem label="采集类型：" prop="collectType">
        <Select v-model="resourceItem.collectType" multiple>
          <Option value="图片">图片</Option>
          <Option value="视频">视频</Option>
          <Option value="声音(中文)">声音(中文)</Option>
          <Option value="声音(英文)">声音(英文)</Option>
          <Option value="声音(其它语种)">声音(其它语种)</Option>
        </Select>
      </FormItem>
      <FormItem label="标注类型：" prop="markType">
        <Select v-model="resourceItem.markType" multiple>
          <Option value="文本">文本</Option>
          <Option value="音频">音频</Option>
          <Option value="图片">图片</Option>
        </Select>
      </FormItem> -->
      <!-- <FormItem label="甲方客户(做过哪些甲方的数据)：" prop="partyA">
        <Input v-model="resourceItem.partyA" autocomplete="off"></Input>
      </FormItem>
      <FormItem label="甲方项目：" prop="partyAProject">
        <Input v-model="resourceItem.partyAProject" autocomplete="off"></Input>
      </FormItem> -->

      <FormItem label="甲方项目：" prop="partyAProjects">
        <div v-for="(item, index) in resourceItem.partyAProjects" :key="index">
          <Row :gutter="8" class="margin-bottom-10" v-if="item.status == 0">
            <Col :span="22">
              <Input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 6 }"
                placeholder="必填，输入框不能为空，如果没有内容，请删除输入框。"
                v-model="item.name"
              ></Input>
            </Col>
            <Col :span="2">
              <Poptip
                placement="left"
                confirm
                title="确定删除这条甲方项目吗？"
                @on-ok="
                  item.id
                    ? (item.status = -1)
                    : resourceItem.partyAProjects.splice(index, 1)
                "
              >
                <Button type="error" icon="md-remove" shape="circle"></Button>
              </Poptip>
            </Col>
          </Row>
        </div>
        <Button
          type="success"
          icon="md-add"
          shape="circle"
          @click="addPartyAProjects"
        >
          添加甲方项目
        </Button>
      </FormItem>
      <FormItem label="地址：" prop="address">
        <Input v-model="resourceItem.address" autocomplete="off"></Input>
      </FormItem>
      <FormItem label="项目区域:" prop="regions">
        <Input v-model="resourceItem.regions" autocomplete="off"></Input>
      </FormItem>
      <FormItem label="能力：" prop="ability">
        <Input v-model="resourceItem.ability" autocomplete="off"></Input>
      </FormItem>
      <FormItem label="规模：" prop="scale">
        <!-- <Input v-model="resourceItem.scale" autocomplete="off" ></Input> -->
        全职人数：
        <InputNumber
          :min="0"
          v-model="resourceItem.fullTime"
          style="width:100px;"
          autocomplete="off"
        ></InputNumber>
        兼职人数：
        <InputNumber
          :min="0"
          v-model="resourceItem.partTime"
          style="width:100px;"
          autocomplete="off"
        ></InputNumber>
      </FormItem>

      <FormItem
        label="联系人："
        v-for="(item, index) in resourceItem.contacts"
        :key="index"
      >
        <Row class="margin-top-10">
          姓名：
          <Input
            v-model="item.name"
            autocomplete="off"
            style="width:100px;"
          ></Input>
          固话：
          <Input
            v-model="item.phone"
            autocomplete="off"
            style="width:100px;"
          ></Input>
          手机：
          <Input
            v-model="item.mobile"
            autocomplete="off"
            style="width:100px;"
          ></Input>
        </Row>
        <Row class="margin-top-10">
          微信：
          <Input
            v-model="item.wechat"
            autocomplete="off"
            style="width:100px;"
          ></Input>
          邮箱：
          <Input
            v-model="item.email"
            autocomplete="off"
            style="width:100px;"
          ></Input>
          QQ：
          <Input
            v-model="item.qq"
            autocomplete="off"
            style="width:100px;"
          ></Input>
        </Row>
        <Row class="margin-top-10">
          其它：
          <Input
            v-model="item.otherContact"
            autocomplete="off"
            style="width:100px;"
          ></Input>

          <Button
            style="margin-left:10px;"
            type="error"
            @click="deleteContact(index)"
          >
            删除联系人
          </Button>
        </Row>
      </FormItem>
      <FormItem>
        <Row class="margin-top-10">
          <Button type="primary" @click="addContact">添加联系人</Button>
        </Row>
      </FormItem>

      <FormItem label="与公司或员工关系：" prop="relationshipKnow">
        <Select v-model="resourceItem.relationshipKnow">
          <Option value="认识">认识</Option>
          <Option value="不认识">不认识</Option>
        </Select>
        <div v-if="resourceItem.relationshipKnow == '认识'">
          关系：
          <Input v-model="resourceItem.relationship" autocomplete="off"></Input>
        </div>
      </FormItem>
      <!-- <FormItem label="与公司合作过的任务：">
        <Input v-model="resourceItem.oldjob" autocomplete="off"></Input>
      </FormItem> -->
      <FormItem label="参与公司合作项目：">
        <div v-for="(item, index) in resourceItem.cooperations" :key="index">
          <Row :gutter="8" class="margin-bottom-10" v-if="item.status == 0">
            <Col :span="22">
              <Input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 6 }"
                placeholder="必填，输入框不能为空，如果没有内容，请删除输入框。"
                v-model="item.name"
              ></Input>
            </Col>
            <Col :span="2">
              <Poptip
                placement="left"
                confirm
                title="确定删除这条合作项目吗？"
                @on-ok="
                  item.id
                    ? (item.status = -1)
                    : resourceItem.cooperations.splice(index, 1)
                "
              >
                <Button type="error" icon="md-remove" shape="circle"></Button>
              </Poptip>
            </Col>
          </Row>
        </div>
        <Button
          type="success"
          icon="md-add"
          shape="circle"
          @click="addCooperation"
        >
          添加合作项目
        </Button>
      </FormItem>
      <FormItem label="参与公司评估项目：">
        <div v-for="(item, index) in resourceItem.assessments" :key="index">
          <Row :gutter="8" class="margin-bottom-10" v-if="item.status == 0">
            <Col :span="22">
              <Input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 6 }"
                placeholder="必填，输入框不能为空，如果没有内容，请删除输入框。"
                v-model="item.name"
              ></Input>
            </Col>
            <Col :span="2">
              <Poptip
                placement="left"
                confirm
                title="确定删除这条评估项目吗？"
                @on-ok="
                  item.id
                    ? (item.status = -1)
                    : resourceItem.assessments.splice(index, 1)
                "
              >
                <Button type="error" icon="md-remove" shape="circle"></Button>
              </Poptip>
            </Col>
          </Row>
        </div>
        <Button
          type="success"
          icon="md-add"
          shape="circle"
          @click="addAssessment"
        >
          添加评估项目
        </Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        resourceTypeData: [],
        resourceItem: {
          fullTime: 0,
          partTime: 0,
          // collectType: [],
          contacts: [
            {
              name: "",
            },
          ],
          cooperations: [
            {
              name: "",
              status: 0,
            },
          ],
          assessments: [
            {
              name: "",
              status: 0,
            },
          ],
          partyAProjects: [
            {
              name: "",
              status: 0,
            },
          ],
        },
        formValidate: {
          // resourceTypeId: [
          //   {
          //     required: true,
          //     type: "number",
          //     trigger: "change",
          //     validator: (rule, value) => {
          //       return new Promise((resolve, reject) => {
          //         if (
          //           !this.resourceItem.resourceTypeId ||
          //           this.resourceItem.resourceTypeId < 1
          //         ) {
          //           reject("必须选择资源类型");
          //         } else {
          //           resolve();
          //         }
          //       });
          //     },
          //   },
          // ],
          resourceTypeM2Ms: [
            { required: true, type: "array", trigger: "change" },
          ],
          groupType: [
            {
              required: true,
              trigger: "change",
            },
          ],
          providerLevel: [
            {
              required: true,
              type: "number",
              trigger: "change",
            },
          ],
          companyName: [
            {
              required: true,
              trigger: "change",
            },
          ],
          // collectType: [
          //   {
          //     type: "array",
          //     validator: (rule, value) => {
          //       return new Promise((resolve, reject) => {
          //         if (
          //           (!this.resourceItem.markType ||
          //             this.resourceItem.markType.length == 0) &&
          //           (!value || value.length === 0)
          //         ) {
          //           reject("必须选择标注类型或者采集类型"); // reject with error message
          //         } else {
          //           resolve();
          //         }
          //       });
          //     },
          //     trigger: "change",
          //   },
          // ],
          // markType: [
          //   {
          //     type: "array",
          //     validator: (rule, value) => {
          //       return new Promise((resolve, reject) => {
          //         if (
          //           (!this.resourceItem.collectType ||
          //             this.resourceItem.collectType.length == 0) &&
          //           (!value || value.length === 0)
          //         ) {
          //           reject("必须选择标注类型或者采集类型"); // reject with error message
          //         } else {
          //           resolve();
          //         }
          //       });
          //     },
          //     trigger: "change",
          //   },
          // ],
          // partyA: [
          //   {
          //     required: true,
          //     trigger: "blur",
          //   },
          // ],
          // partyAProject: [
          //   {
          //     required: true,
          //     trigger: "blur",
          //   },
          // ],
          partyAProjects: [
            { required: true, type: "array", trigger: "change" },
          ],
          address: [
            {
              required: true,
              trigger: "blur",
            },
          ],
          // ability: [
          //   {
          //     required: true,
          //     trigger: "blur",
          //   },
          // ],
        },
      };
    },
    props: {
      resourceTypeList: {
        type: Array,
        default: () => {
          return [];
        },
      },
    },
    watch: {
      resourceTypeList(value) {
        this.resourceTypeData = value;
      },
    },
    methods: {
      getData(call) {
        this.$refs.formValidate.validate((v) => {
          if (v) {
            let formData = { ...this.resourceItem };

            // if (formData.collectType)
            //   formData.collectType = formData.collectType.join(",");

            // if (formData.markType) {
            //   if (typeof formData.markType != "string")
            //     formData.markType = formData.markType.join(",");
            // }

            if (
              formData &&
              formData.resourceTypeM2Ms &&
              formData.resourceTypeM2Ms.length
            ) {
              formData.resourceTypeM2Ms.forEach((x) => {
                //数据库只需保存最后层级
                if (x.resourceTypeIds && x.resourceTypeIds.length > 0) {
                  x.resourceTypeId =
                    x.resourceTypeIds[x.resourceTypeIds.length - 1];
                } else {
                  x.resourceTypeId = 0;
                }
              });
            }

            call(formData);
          } else {
            this.$Message.error("请填写全部相关内容!");
          }
        });
      },
      clearData() {
        this.resourceItem = {
          fullTime: 0,
          partTime: 0,
          // collectType: [],
          contacts: [
            {
              name: "",
              status: 0,
            },
          ],
          cooperations: [
            {
              name: "",
              status: 0,
            },
          ],
          assessments: [
            {
              name: "",
              status: 0,
            },
          ],
          partyAProjects: [
            {
              name: "",
              status: 0,
            },
          ],
          resourceTypeM2Ms: [],
        };
      },
      setData(data) {
        // this.resourceItem = JSON.parse(JSON.stringify(data));
        this.resourceItem = data;

        // if (this.resourceItem.collectType)
        //   this.resourceItem.collectType = this.resourceItem.collectType.split(
        //     ","
        //   );
        // if (this.resourceItem.markType)
        //   this.resourceItem.markType = this.resourceItem.markType.split(",");

        //this.resourceItem.providerLevel = this.resourceItem.providerLevel.toString();
      },
      addContact() {
        this.resourceItem.contacts.push({
          name: "",
          // phone: "",
          // mobile: "",
          // wechat: "",
          // qq: "",
          // email: "",
          // otherContact: "",
        });
      },
      deleteContact(index) {
        this.resourceItem.contacts.splice(index, 1);
      },

      resourceTypeChange(values, selectedDatas) {
        if (values && values.length > 0) {
          this.resourceItem.resourceTypeId = values[values.length - 1];
        } else {
          this.resourceItem.resourceTypeId = 0;
        }
      },
      addCooperation() {
        if (!this.resourceItem.cooperations)
          this.resourceItem.cooperations = [];
        this.resourceItem.cooperations.push({
          name: "",
          status: 0,
        });
      },
      addAssessment() {
        if (!this.resourceItem.assessments) this.resourceItem.assessments = [];
        this.resourceItem.assessments.push({
          name: "",
          status: 0,
        });
      },
      addResourceTypeM2M() {
        if (!this.resourceItem.resourceTypeM2Ms)
          this.resourceItem.resourceTypeM2Ms = [];

        this.resourceItem.resourceTypeM2Ms.push({
          // resourceTypeIds: [],
          // resourceId: this.resourceItem.id,
        });
      },
      addPartyAProjects() {
        if (!this.resourceItem.partyAProjects)
          this.resourceItem.partyAProjects = [];
        this.resourceItem.partyAProjects.push({
          name: "",
          status: 0,
        });
      },
    },
  };
</script>
